"use strict";

exports.__esModule = true;
var _UpdatePlantStateActivitiesScreen = require("./UpdatePlantStateActivitiesScreen");
Object.keys(_UpdatePlantStateActivitiesScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UpdatePlantStateActivitiesScreen[key]) return;
  exports[key] = _UpdatePlantStateActivitiesScreen[key];
});